import type { GettextFn } from "@/types";

export const emailInviteUserToPartnerNew = (gettext: GettextFn) => {
  return `
    <tr>
      <td>${gettext("Dear {{user_full_name}}")},</td>
    </tr>
    <tr>
        <td>${gettext("You have invited by the {{partner_name}} to join as {{role_name}}. To continue, you must create a password to access the system.")}</td>
    </tr>
    <tr>
        <td>
            <a class="link-button" href="{{create_password_link}}" style="color: #FFFFFF">${gettext("Create a new password")}</a>
        </td>
    </tr>
`;
};
